"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderNameInput = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var FolderNameInput = (function (_super) {
    __extends(FolderNameInput, _super);
    function FolderNameInput(props) {
        var _this = _super.call(this, props) || this;
        _this.renamedFolderName = null;
        _this.isRenaming = false;
        _this.hasErrored = false;
        _this.inputRef = react_1.default.createRef();
        _this.handleOnBlur = function () { return __awaiter(_this, void 0, void 0, function () {
            var trimmedName, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        trimmedName = this.renamedFolderName.trim();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!(trimmedName !== "" && trimmedName !== this.props.folderName)) return [3, 3];
                        return [4, this.props.changeFolderName(this.props.folderId, trimmedName)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3, 5];
                    case 4:
                        e_1 = _a.sent();
                        this.resetFolderName();
                        this.setHasErrored(true);
                        setTimeout(function () {
                            _this.setHasErrored(false);
                        }, kaleidoscope_1.ErrorTooltipTimeout);
                        return [3, 5];
                    case 5:
                        this.resetFolderName();
                        return [2];
                }
            });
        }); };
        _this.handleKeyDown = function (event) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (event.key === "Escape") {
                    this.resetFolderName();
                    this.inputRef.current.blur();
                }
                else if (event.key === "Enter") {
                    this.inputRef.current.blur();
                }
                return [2];
            });
        }); };
        return _this;
    }
    FolderNameInput.prototype.render = function () {
        var _a;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("dashboard-folder-name-title", this.props.className) },
            react_1.default.createElement(icons_1.Folder, { size: icons_1.IconSize.Large }),
            react_1.default.createElement(kaleidoscope_1.ErrorTooltip, { renderTooltip: this.hasErrored, content: "Error updating folder name. Try again later.", position: kaleidoscope_2.TooltipPosition.Top, size: kaleidoscope_2.TooltipSize.Large },
                react_1.default.createElement("input", { ref: this.inputRef, className: (0, classnames_1.default)("dashboard-folder-name-title__input", (_a = {},
                        _a["dashboard-folder-name-title__input--show-border"] = this.hasErrored,
                        _a["dashboard-folder-name-title__input--disabled"] = this.props.isDisabled,
                        _a)), disabled: this.props.isDisabled, value: this.isRenaming ? this.renamedFolderName : this.props.folderName, onChange: this.onFolderNameChange, onBlur: this.handleOnBlur, onKeyDown: this.handleKeyDown, maxLength: this.props.maxLength }))));
    };
    FolderNameInput.prototype.onFolderNameChange = function (event) {
        this.isRenaming = true;
        if (!this.renamedFolderName) {
            this.renamedFolderName = this.props.folderName;
        }
        this.hasErrored = false;
        this.renamedFolderName = event.target.value;
    };
    FolderNameInput.prototype.resetFolderName = function () {
        this.isRenaming = false;
        this.renamedFolderName = this.props.folderName;
    };
    FolderNameInput.prototype.setHasErrored = function (errored) {
        this.hasErrored = errored;
    };
    var _a;
    FolderNameInput.defaultProps = {
        maxLength: 256,
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], FolderNameInput.prototype, "renamedFolderName", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], FolderNameInput.prototype, "isRenaming", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], FolderNameInput.prototype, "hasErrored", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof react_1.default !== "undefined" && react_1.default.ChangeEvent) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], FolderNameInput.prototype, "onFolderNameChange", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], FolderNameInput.prototype, "handleOnBlur", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FolderNameInput.prototype, "resetFolderName", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], FolderNameInput.prototype, "setHasErrored", null);
    FolderNameInput = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], FolderNameInput);
    return FolderNameInput;
}(react_1.Component));
exports.FolderNameInput = FolderNameInput;
